import { openInBlobInBlank } from "../../../../../common/utils/view_utils";
import { IDownloadFuncionarioDocumentoByIdUseCase } from "../../../presentation/useCases/read/download_funcionario_documento_by_id_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DownloadFuncionarioDocumentoByIdUseCase
 */

export class DownloadFuncionarioDocumentoByIdUseCase implements IDownloadFuncionarioDocumentoByIdUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async downloadFuncionarioDocumentoById(
    idFuncionarioArquivo: number,
    nomeArquivo: string
  ): Promise<void> {
    const blob = await this.repository.downloadFuncionarioDocumentoById(idFuncionarioArquivo);
    await openInBlobInBlank(nomeArquivo, blob);
  }
}
